import React, {FC, ReactNode} from 'react'

// @ts-ignore
import styles from './Note.scss'

type NoteProps = {
  children: ReactNode
}

export const Note: FC<NoteProps> = ({ children }) => {
  return <span className={styles.note}>{children}</span>
}
